module.exports = __webpack_public_path__ + "static/media/29FUNOV9.bd813e37.jpg";